import { css } from "@emotion/react";
import { CHIP_HEIGHT } from "../Chip/styles";
import { kitText } from "../../styles";

export const CHIPS_OVERFLOW_CLASS = "chipOverflow";

export const styles = {
  wrapper: css`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  `,
  isDisabled: css`
    color: var(--color-secondary);
  `,
  noWrap: css`
    flex-wrap: no-wrap;
    height: ${CHIP_HEIGHT};
    overflow-y: hidden;
    counter-reset: overflowChips var(--total-chips);
    position: relative;

    > :not(.${CHIPS_OVERFLOW_CLASS}) {
      counter-increment: overflowChips -1;
    }

    > :has(+ .${CHIPS_OVERFLOW_CLASS}):after {
      content: "+ " counter(overflowChips);
      ${kitText.variant.body}
    }
  `
};
